import useRequest from '@/websdk/utils/request';

export default function () {
  const { data, exec } = useRequest({
    url: '/api/additives',
    name: 'GET_ADDITIVES',
  });

  return [data || [], exec];
}
